import env from "../../utils/env";

let JobsService = function (HttpService) {
  "ngInject";

  const getDataSource = (successCb) => {
    const dataSource = new kendo.data.DataSource({
      transport: {
        read: {
          url: env.getApiUrl("jobs/search"),
          contentType: "application/json",
          type: "POST",
          beforeSend: _onBeforeSend,
        },
        update: {
          url: _getResourceLocation,
          contentType: "application/json",
          type: "PATCH",
          beforeSend: _onBeforeSend,
        },
        parameterMap: _parameterMap
      },
      change: successCb,
      schema: {
        data: "data",
        total: "total",
      },
      serverFiltering: true,
      serverPaging: true,
      serverSorting: true,
      pageSize: 50
    })

    return dataSource;
  }

  const getJobPaymentDetails = (jobId, successCb, failureCb) => {
    HttpService.get(`jobs/${jobId}/payment-details`, successCb, failureCb);
  }

  const getJobDetails = (jobId, successCb, failureCb) => {
    HttpService.get(`jobs/${jobId}`, successCb, failureCb);
  }

  const updateJobPricing = (jobId, data, successCb, failureCb) => {
    HttpService.put(`jobs/${jobId}/pricing`, data, successCb, failureCb);
  }

  const payHelper = (invoiceId, successCb, failureCb) => {
    console.log('JobsService.payHelper called with invoiceId:', invoiceId);
    HttpService.post(`payments/helper/${invoiceId}`, null, successCb, failureCb);
  }

  const deleteTimesheet = (jobId, successCb, failureCb) => {
    HttpService.patch(`jobs/${jobId}/timesheet`, { status: 12 }, successCb, failureCb);
  }

  const getJugglerJobsDataSource = (userId) => {
    const dataSource = new kendo.data.DataSource({
      transport: {
        read: {
          url: env.getApiUrl(`jobs/juggler/${userId}`),
          contentType: "application/json",
          type: "GET",
          cache: false,
          beforeSend: _onBeforeSend,
        },
        update: {
          url: (item) => env.getApiUrl(`jobs/${item.id || item.jobId || item.JobId || item.Id}/pricing`),
          contentType: "application/json",
          type: "PUT",
          beforeSend: _onBeforeSend,
        },
        parameterMap: (data, type) => {
          if (type === "update") {
            return JSON.stringify({
              price: data.price || data.Price,
              overtimeRate: data.overtimeRate || data.OvertimeRate,
              estimatedJobValue: data.estimatedJobValue || data.EstimatedJobValue
            });
          }
        }
      },
      schema: {

        model: {
          id: "id", // Assuming id or jobId is present. Handled in update url safely.
          fields: {
            id: { editable: false },
            jobId: { editable: false },
            paymentType: { editable: false },
            PaymentType: { editable: false },
            jobDate: { editable: false },
            JobDate: { editable: false },
            jobStartTime: { editable: false },
            JobStartTime: { editable: false },
            jobEndTime: { editable: false },
            JobEndTime: { editable: false },
            estimatedJobHours: { editable: false },
            EstimatedJobHours: { editable: false },
            price: { type: "number", validation: { min: 0 } },
            Price: { type: "number", validation: { min: 0 } },
            overtimeRate: { type: "number", validation: { min: 0 } },
            OvertimeRate: { type: "number", validation: { min: 0 } },
            estimatedJobValue: { type: "number", validation: { min: 0 } },
            EstimatedJobValue: { type: "number", validation: { min: 0 } }
          }
        }
      },
      serverFiltering: false,
      serverPaging: false,
      serverSorting: false,
      pageSize: 50
    });

    return dataSource;
  }

  return { getDataSource, getJugglerJobsDataSource, getJobPaymentDetails, getJobDetails, updateJobPricing, payHelper, deleteTimesheet };
}

function _getResourceLocation(options) {
  return env.getApiUrl(`bigfoot/medias/${options.id}`);
}

function _onBeforeSend(req) {
  var token = `Bearer ${window.localStorage.getItem("bigfootAccessToken")}`;

  req.setRequestHeader("Authorization", token);
}

function _parameterMap(data, type) {
  if (type == "read") {
    let filters = [];

    if (data.filter) filters = data.filter.filters;

    let query = Object.assign({}, { filters: filters }, data)
    delete query.filter;

    console.log("Query::", query)

    return JSON.stringify(query);
  }

  if (type == "update") {
    return JSON.stringify(data);
  }
}

export default JobsService;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/services/jobs.service.js
 **/